import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

function PaymentResult() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const orderId = params.get("order_id");
  const certificateId = params.get("certificate_id");

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        console.log("PaymentResult received params:", { orderId, certificateId });

        if (!orderId || !certificateId) {
          console.error("Missing orderId or certificateId", { orderId, certificateId });
          navigate("/payment-failed");
          return;
        }

        console.log(`Fetching from: ${process.env.REACT_APP_API_URL}/api/payment/check-order-status?order_id=${orderId}`);

        // Check payment status from Cashfree
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/payment/check-order-status?order_id=${orderId}`
        );
        
        console.log("API response status:", res.status);
        
        const data = await res.json();
        
        console.log("Payment status response:", data);

        if (data.success && data.order_status === "PAID") {
          // Payment successful - redirect to thank you
          console.log("✅ Payment successful, redirecting to thank you");
          navigate(`/thank-you?certificate_id=${certificateId}&order_id=${orderId}`);
        } else {
          // Payment failed
          console.log("❌ Payment not paid:", data.order_status, "- redirecting to payment failed");
          navigate(`/payment-failed?txnid=${orderId}`);
        }
      } catch (err) {
        console.error("Error checking payment status:", err);
        navigate("/payment-failed");
      }
    };

    checkPaymentStatus();
  }, [orderId, certificateId, navigate]);

  return null; // no UI
}

export default PaymentResult;